<template>
  <section>
    <svg
      id="icon_minus"
      width="18"
      height="25"
      viewBox="0 0 22 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1H11H21"
        stroke="#121212"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </section>
</template>

<style scoped>
#icon_minus:hover path {
  stroke: #ff8b41;
}
</style>
